module.exports = __webpack_public_path__ + "img/log-out.6bdf2728.svg";